var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 139,
    viewBox: "0 0 147 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_2383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8762 40.2173C73.8762 40.2173 75.3451 53.9275 81.0666 59.649C86.7881 65.3705 100.498 66.8394 100.498 66.8394C100.498 66.8394 86.7881 68.3082 81.0666 74.0297C75.3451 79.7512 73.8762 93.4614 73.8762 93.4614C73.8762 93.4614 72.4073 79.7512 66.6858 74.0297C60.9644 68.3082 47.2542 66.8394 47.2542 66.8394C47.2542 66.8394 60.9644 65.3705 66.6858 59.649C72.4073 53.9275 73.8762 40.2173 73.8762 40.2173Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.465 72.1641C120.465 72.1641 121.934 85.8743 127.655 91.5958C133.377 97.3173 147.087 98.7861 147.087 98.7861C147.087 98.7861 133.377 100.255 127.655 105.977C121.934 111.698 120.465 125.408 120.465 125.408C120.465 125.408 118.996 111.698 113.274 105.977C107.553 100.255 93.8428 98.7861 93.8428 98.7861C93.8428 98.7861 107.553 97.3173 113.274 91.5958C118.996 85.8743 120.465 72.1641 120.465 72.1641Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6221 91.4648C26.6221 91.4648 28.091 111.687 33.8125 120.127C39.5339 128.566 53.2441 130.732 53.2441 130.732C53.2441 130.732 39.5339 132.899 33.8125 141.338C28.091 149.777 26.6221 170 26.6221 170C26.6221 170 25.1532 149.777 19.4317 141.338C13.7102 132.899 0 130.732 0 130.732C0 130.732 13.7102 128.566 19.4317 120.127C25.1532 111.687 26.6221 91.4648 26.6221 91.4648Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.142 -29C114.142 -29 115.262 -8.77745 119.625 -0.338247C123.987 8.10096 134.441 10.2676 134.441 10.2676C134.441 10.2676 123.987 12.4342 119.625 20.8734C115.262 29.3126 114.142 49.5351 114.142 49.5351C114.142 49.5351 113.022 29.3126 108.659 20.8734C104.297 12.4342 93.8428 10.2676 93.8428 10.2676C93.8428 10.2676 104.297 8.10096 108.659 -0.338247C113.022 -8.77745 114.142 -29 114.142 -29Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9548 23.5786C26.9548 23.5786 28.0749 33.8613 32.4375 38.1524C36.8002 42.4435 47.2542 43.5452 47.2542 43.5452C47.2542 43.5452 36.8002 44.6468 32.4375 48.938C28.0749 53.2291 26.9548 63.5117 26.9548 63.5117C26.9548 63.5117 25.8348 53.2291 21.4722 48.938C17.1095 44.6468 6.65552 43.5452 6.65552 43.5452C6.65552 43.5452 17.1095 42.4435 21.4722 38.1524C25.8348 33.8613 26.9548 23.5786 26.9548 23.5786Z",
    fill: "white",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_2383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 139,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentbar);
export default __webpack_public_path__ + "static/media/studentbar.524215aa41b600c995119479478eb649.svg";
export { ForwardRef as ReactComponent };